export const ALPHANUMERIC_PATTERN = /^[A-Za-z0-9\s]*$/;
export const NUMBER_PATTERN = /^[0-9]\d*$/;
export const YEAR_PATTERN = /^\d{1,4}$/;
